import useChangeBranchHook from "@/shared/hooks/useChangeBranchHook";
import useSetUserByParams from "@/shared/hooks/useSetUserByParams";

/* it was created prevent re-rendering of the globals  */

const DynamicGlobals = () => {
  useSetUserByParams();
  useChangeBranchHook();
  return null;
};

export default DynamicGlobals;
